import { translate, useLocale } from "../localization";
import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { AppButton, AppTextField } from "./ui";

const AuthForm = ({
  title,
  fields,
  onSubmit,
  isLoading,
  footerAction,
  submitLabel = translate("Submit"),
  maxWidth = 400
}) => {
  useLocale();
  return <Box width="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
    <Box width="100%" maxWidth={maxWidth} p={{
      xs: 3,
      sm: 4
    }} bgcolor="var(--color-bg-card, #ffffff)" boxSizing="border-box" sx={{
      borderRadius: "16px",
      boxShadow: "var(--shadow-card-hover, 0 12px 36px rgba(0, 0, 0, 0.18))"
    }}>
      <Typography variant="h2" component="h1" align="center" gutterBottom>
        {title}
      </Typography>
      <Box component="form" onSubmit={e => {
        e.preventDefault();
        onSubmit();
      }} noValidate>
        {fields.map(({
          label,
          type,
          value,
          onChange
        }, index) => <AppTextField key={index} label={label} type={type} fullWidth margin="normal" value={value} onChange={onChange} required InputLabelProps={{
          shrink: true // Force the label to shrink
        }} />)}
        <Box display="flex" justifyContent="center" marginTop={2}>
          <AppButton type="submit" fullWidth disabled={isLoading}>
            {isLoading ? <CircularProgress size={24} /> : submitLabel}
          </AppButton>
        </Box>
      </Box>
      {footerAction && <Box textAlign="center" marginTop={2}>
          {footerAction}
        </Box>}
    </Box>
  </Box>;
};

export default AuthForm;
